/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightOkKreis: {
    name: 'big-light-ok-kreis';
    data: string;
} = {
    name: 'big-light-ok-kreis',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M117.81 41a2.5 2.5 0 1 0-4.6 2 53.5 53.5 0 1 1-23.42-25.88 2.51 2.51 0 0 0 3.4-1 2.49 2.49 0 0 0-1-3.39A58.45 58.45 0 1 0 117.81 41"/><path d="M52.48 83.2a1.5 1.5 0 0 1-1 .59 1.52 1.52 0 0 1-1.12-.32l-16.8-13.42A2.5 2.5 0 1 0 30.44 74l16.78 13.37a6.37 6.37 0 0 0 4 1.43 8 8 0 0 0 .83 0 6.44 6.44 0 0 0 4.34-2.49l50.48-59.64a2.5 2.5 0 1 0-3.82-3.24L52.57 83.08z"/></svg>`,
};
